<template>
  <div class="app-video">
    <video id=”media” :src="vUrl" controls></video>
  </div>
</template>

<script>

export default {
  name: 'AppVideo',
  data() {
    return {
      vId: '', //视频名称
      vUrl: ''
    }
  },
  mounted() {
    this.vId =  this.$route.params.vId
    this.vUrl = this.getVideoObj()
  },
  methods: {
    getVideoObj() {
      const id = this.vId
      switch (id) {
        case "pendibaoyang":
          return 'http://dsmm-elechcy.oss-cn-shenzhen.aliyuncs.com/app/prd/video/bz/pendibaoyang.mp4'
        case "pendikangfuzhiliao":
          return 'http://dsmm-elechcy.oss-cn-shenzhen.aliyuncs.com/app/prd/video/bz/pendikangfuzhiliao.mp4'
        case "tishengnvxinggongneng":
          return 'http://dsmm-elechcy.oss-cn-shenzhen.aliyuncs.com/app/prd/video/bz/tishengnvxinggongneng.mp4'
        case "jinjizheng":
          return 'http://dsmm-elechcy.oss-cn-shenzhen.aliyuncs.com/app/prd/video/jjz/jinjizheng.mp4'
        case "pendipingu":
          return 'http://dsmm-elechcy.oss-cn-shenzhen.aliyuncs.com/app/prd/video/pdpg/pendipingu.mp4'
        case "pendipingulianxian":
          return 'http://dsmm-elechcy.oss-cn-shenzhen.aliyuncs.com/app/prd/video/syjx/pendipingulianxian.mp4'
        case "shoucipingutuijian":
          return 'http://dsmm-elechcy.oss-cn-shenzhen.aliyuncs.com/app/prd/video/scpg/shoucipingutuijian.mp4'
        case "fuwujieshao":
          return 'http://dsmm-elechcy.oss-cn-shenzhen.aliyuncs.com/app/prd/video/hyfw/fuwujieshao.mp4'
        case "paopaosaiche":
          return 'http://dsmm-elechcy.oss-cn-shenzhen.aliyuncs.com/app/prd/video/yxfa/paopaosaiche.mp4'
        case "taikongaoyou":
          return 'http://dsmm-elechcy.oss-cn-shenzhen.aliyuncs.com/app/prd/video/yxfa/taikongaoyou.mp4'
        case "chunshengwufankui":
          return 'http://dsmm-elechcy.oss-cn-shenzhen.aliyuncs.com/app/prd/video/syjx/chunshengwufankui.mp4'
        case "dantongdaodianciji":
          return 'http://dsmm-elechcy.oss-cn-shenzhen.aliyuncs.com/app/prd/video/syjx/dantongdaodianciji.mp4'
        case "shengwufankuidianciji":
          return 'http://dsmm-elechcy.oss-cn-shenzhen.aliyuncs.com/app/prd/video/syjx/shengwufankuidianciji.mp4'
        case "shuangtongdaodianciji":
          return 'http://dsmm-elechcy.oss-cn-shenzhen.aliyuncs.com/app/prd/video/syjx/shuangtongdaodianciji.mp4'
        case "shiyongshuoming":
          return 'https://dsmm-elechcy.oss-cn-shenzhen.aliyuncs.com/app/prd/video/shiyongshuoming.mp4'
        case "cujinxueyexunhuan":
          return 'http://dsmm-elechcy.oss-cn-shenzhen.aliyuncs.com/app/prd/video/zxdl/cujinxueyexunhuan.mp4'
        case "erleijiduanlian":
          return 'http://dsmm-elechcy.oss-cn-shenzhen.aliyuncs.com/app/prd/video/zxpddl/erleijiduanlian.mp4'
        case "hunhejiduanlian":
          return 'http://dsmm-elechcy.oss-cn-shenzhen.aliyuncs.com/app/prd/video/zxpddl/hunhejiduanlian.mp4'
        case "qingjingmoni":
          return 'http://dsmm-elechcy.oss-cn-shenzhen.aliyuncs.com/app/prd/video/zxpddl/qingjingmoni.mp4'
        case "yileijiduanlian":
          return 'http://dsmm-elechcy.oss-cn-shenzhen.aliyuncs.com/app/prd/video/zxpddl/yileijiduanlian.mp4'
        case "haidishijie":
          return 'http://dsmm-elechcy.oss-cn-shenzhen.aliyuncs.com/app/prd/video/yxfa/haidishijie.mp4'
        case "hudiexianzi":
          return 'http://dsmm-elechcy.oss-cn-shenzhen.aliyuncs.com/app/prd/video/yxfa/hudiexianzi.mp4'
        case "bangdingzhuji":
          return 'http://dsmm-elechcy.oss-cn-shenzhen.aliyuncs.com/app/prd/video/sysp/bangdingzhuji.mp4'
        case "shiyonghoushixiang":
          return 'http://dsmm-elechcy.oss-cn-shenzhen.aliyuncs.com/app/prd/video/sysp/shiyonghoushixiang.mp4'
        case 'chankangfuzhiji':
          return 'https://dsmm-elechcy.oss-cn-shenzhen.aliyuncs.com/app/prd/video/chankangfuzhiji.mp4'
        case 'chankangzigongfujiu':
          return 'https://dsmm-elechcy.oss-cn-shenzhen.aliyuncs.com/app/prd/video/chankangzigongfujiu.mp4'
        default:
          return 'http://dsmm-elechcy.oss-cn-shenzhen.aliyuncs.com/app/prd/video/bz/pendibaoyang.mp4'
      }
    },
  },
}
</script>

<style scoped>
.app-video video {
  height: 100vh;
  width: 100%;
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/pages/AppVideo.vue